import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import FoundationDiagramAct3 from "./FoundationDiagramAct3";

const PlatformAct3 = () => {
  return (
    <section className="bg-background py-section border-t border-border">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <Reveal className="lg:col-span-6">
            <p className="eyebrow">How it works</p>
            <h2 className="display mt-5 text-section-title text-foreground">
              One integration.<br className="hidden lg:inline" />{" "}
              <span className="italic font-normal text-primary/95">Every AI workflow</span> across your health system.
            </h2>
          </Reveal>

          <Reveal className="lg:col-span-6 lg:pt-2" delay={0.1}>
            <div className="space-y-6 text-base md:text-lg text-foreground/75 leading-relaxed">
              <p>
                Connect deepc once to the clinical systems you already run —
                EHR, PACS, claims, documents, reporting, and data infrastructure.
                The integration work happens once.
              </p>
              <p>
                On top of that integration layer, your teams can build, deploy, and
                govern AI workflows across the organization - without rebuilding
                integration, monitoring, and governance for every new capability.
              </p>
            </div>

            <div className="mt-10">
              <Link
                to="/solution"
                className="group inline-flex items-center gap-2 text-foreground font-medium border-b border-foreground/30 pb-1 hover:border-primary transition-colors duration-300"
              >
                Explore the solution
                <span aria-hidden className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </Link>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 md:mt-16 relative rounded-2xl border border-border bg-background shadow-sm p-8 md:p-12 lg:p-16 overflow-hidden">
            <div
              aria-hidden
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  "radial-gradient(80% 50% at 50% 0%, hsl(var(--primary) / 0.05), transparent 70%)",
              }}
            />
            <div className="relative">
              <FoundationDiagramAct3 />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default PlatformAct3;
